import $ from 'jquery';

const loadPreview = () => {
  const node = $('.special-finishes-preview');
  const tabs = $('.finish-preview-tabs');

  $('.finish-preview-images').each((i, group) => {
    $(group)
      .find('.responsive-image')
      .each((i, image) => {
        image.style.transitionDelay = `${i * 0.1}s`;
      });
  });

  tabs.on('click', 'a', event => {
    event.preventDefault();
    const link = $(event.currentTarget);
    const href = link.attr('href');
    link.addClass('active');
    tabs.find('a').not(link).removeClass('active');
    node.find('.responsive-image.active').removeClass('active');
    $(`#${href.substring(1)}`)
      .find('.responsive-image')
      .addClass('active');
  });
};

export default loadPreview;
